export const getBannerAspectRatio = (
  isSquareBanner?: boolean | null,
  bannerVideoUrl?: string | null
): "16/9" | "1/1" | undefined => {
  if (bannerVideoUrl) {
    return "16/9";
  }

  return isSquareBanner ? "1/1" : "16/9";
};
